const disposed = new WeakSet();

// Closing a CONNECTING browser socket aborts its handshake and emits a network
// error. Retire the component handlers now, then close normally after open.
// No authentication or subscription is sent by an already disposed component.
export function disposeWebSocket(socket) {
  if (!socket || disposed.has(socket)) return;
  disposed.add(socket);
  socket.onopen = null;
  socket.onmessage = null;
  socket.onerror = null;
  socket.onclose = null;
  const closeOpen = () => {
    if (socket.readyState === WebSocket.OPEN) socket.close();
  };
  if (socket.readyState !== WebSocket.CONNECTING) { closeOpen(); return; }
  const clear = () => {
    socket.removeEventListener('open', finish);
    socket.removeEventListener('close', clear);
  };
  const finish = () => { clear(); closeOpen(); };
  socket.addEventListener('open', finish, { once: true });
  socket.addEventListener('close', clear, { once: true });
}
